import * as api from '../../../clients/veranstaltungen';

import {Action} from '@ngrx/store';

export const GET_VERANSTALTUNG_AKTION2 = '[VeranstaltungenModul] GetVeranstaltungAktion2 laden';
export const GET_VERANSTALTUNG_AKTION2_AUSFUEHREN = '[VeranstaltungenModul] GetVeranstaltungAktion2 ausführen';
export const GET_VERANSTALTUNG_AKTION2_ERFOLGREICH = '[VeranstaltungenModul] GetVeranstaltungAktion2 laden erfolgreich';
export const GET_VERANSTALTUNG_AKTION2_FEHLER = '[VeranstaltungenModul] GetVeranstaltungAktion2 Ladefehler';
export const GET_VERANSTALTUNG_AKTION2_NICHT_AUSGEFUEHRT = '[VeranstaltungenModul] GetVeranstaltungAktion2 nicht ausgeführt (evtl. Offline)';


export class GetVeranstaltungAktion2Action implements Action {
    readonly type = GET_VERANSTALTUNG_AKTION2;
        constructor( public veranstaltung_id:string ,  public aktionId:string , public optPayload: any = null) {}
    }
export class GetVeranstaltungAktion2AusfuehrenAction implements Action {
    readonly type = GET_VERANSTALTUNG_AKTION2_AUSFUEHREN;
        constructor( public veranstaltung_id:string ,  public aktionId:string , public optPayload: any = null) {}
    }
export class GetVeranstaltungAktion2ErfolgreichAction implements Action {
    readonly type = GET_VERANSTALTUNG_AKTION2_ERFOLGREICH;
        constructor(public payload: api.Aktion,  public veranstaltung_id:string ,  public aktionId:string , public optPayload: any = null) {}
    }
export class GetVeranstaltungAktion2FehlerAction implements Action {
    readonly type = GET_VERANSTALTUNG_AKTION2_FEHLER;
        constructor(public payload: any,  public veranstaltung_id:string ,  public aktionId:string , public optPayload: any = null) {}
    }
export class GetVeranstaltungAktion2NichtAusgefuehrtAction implements Action {
    readonly type = GET_VERANSTALTUNG_AKTION2_NICHT_AUSGEFUEHRT;
        constructor(public optPayload: any = null) {}
    }
    

export type VeranstaltungenQueryVeranstaltungAktion2Actions =
    GetVeranstaltungAktion2Action
    | GetVeranstaltungAktion2AusfuehrenAction
    | GetVeranstaltungAktion2ErfolgreichAction
    | GetVeranstaltungAktion2FehlerAction
    | GetVeranstaltungAktion2NichtAusgefuehrtAction
    ;
